module.exports = __webpack_public_path__ + "img/roule_img_02.72e3046e.jpg";